import { getPointAfter, insertNodes } from '@udecode/plate';
import { Range } from 'slate';
import { EditorStateProxy } from '~/composer/composer/entities/EditorStateProxy';
import { makeUnicodeAwareIndexUnaware } from '~/composer/composer/utils/StringUtils';
import { withoutLosingSelection } from '~/editor/helpers/withoutLosingSelection';
import { BufferEditor } from '../../../BufferEditor/types.plate';
import { WithPosition } from '../../../helpers/WithPosition';
import { findCharacterLimitPoint } from '../../character-limit-highlight';
import {
  FacebookMentionEntityDetails,
  FacebookMentionInputElement,
} from '../nodes/FacebookMentionInputElement';

/**
 * Given an editor and a facebook mention entity,
 * find its location in the editor and insert
 * a FacebookMentionInputElement
 */
export const insertFacebookMention = (
  editor: BufferEditor,
  data: WithPosition<FacebookMentionEntityDetails>
): Range | undefined => {
  const { start, length, ...mention } = data;
  // The start index returned from the server will not
  // match exactly as it's been made unicode aware.
  // Get the entire text of the editor to get the
  // unicode unaware start index of the mention.
  const plainText = EditorStateProxy.getPlainText(editor);
  const unicodeUnawareStart = makeUnicodeAwareIndexUnaware(plainText, start);

  const anchor = findCharacterLimitPoint(editor, unicodeUnawareStart);
  const focus =
    anchor &&
    getPointAfter(editor, anchor, {
      distance: length,
    });

  if (!anchor || !focus) return;

  const { name } = mention;

  const element = FacebookMentionInputElement.new(name, mention);

  withoutLosingSelection(editor, () => {
    insertNodes(editor, element, {
      at: { anchor, focus },
    });
  });
};
